// remember flex-wrap: nowrap;
import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import { Title } from 'web-ui-components/lib/atoms/text';

const ReasonsToGoPaperlessListItem = ({ children }) => (
  <li className="c-paperless-reason">
    <Icon iconType="TickSolidLarge" color="utility-tip" />
    {children}
  </li>
);

ReasonsToGoPaperlessListItem.propTypes = {
  children: PropTypes.string,
};

export const ReasonsToGoPaperlessList = ({ content }) => {
  return (
    <HighlightTile type="info">
      <Title size="h4" className="c-paperless-title">
        {content.paperlessReasonsTitle}
      </Title>
      <ul className="c-paperless-reason-list">
        <ReasonsToGoPaperlessListItem>
          {content.paperlessReason1}
        </ReasonsToGoPaperlessListItem>
        <ReasonsToGoPaperlessListItem>
          {content.paperlessReason2}
        </ReasonsToGoPaperlessListItem>
        <ReasonsToGoPaperlessListItem>
          {content.paperlessReason3}
        </ReasonsToGoPaperlessListItem>
        <ReasonsToGoPaperlessListItem>
          {content.paperlessReason4}
        </ReasonsToGoPaperlessListItem>
        <ReasonsToGoPaperlessListItem>
          {content.paperlessReason5}
        </ReasonsToGoPaperlessListItem>
      </ul>
    </HighlightTile>
  );
};

ReasonsToGoPaperlessList.propTypes = {
  content: PropTypes.shape({
    paperlessReasonsTitle: PropTypes.string,
    paperlessReason1: PropTypes.string,
    paperlessReason2: PropTypes.string,
    paperlessReason3: PropTypes.string,
    paperlessReason4: PropTypes.string,
    paperlessReason5: PropTypes.string,
  }),
};
